// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Match BenchmarkHeatmap.module.scss .card + .title + chart height (360px) */
.RelatedConceptsPanel_card__b8nRG {
  padding: 24px 24px 18px;
  background: var(--bg-2, #fff);
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  /* Title + 360px region mirrors BenchmarkHeatmap (title + chart 360px) */
}

/* Match BenchmarkHeatmap .title (margin 0 0 10px) so card heights line up */
.RelatedConceptsPanel_title__cyNDi {
  margin: 0 0 10px;
  font-family: "Lora", "Georgia", serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
}

/*
 * Same vertical band as heatmap title→chart: 10px gap + 360px plot.
 * Extra title→chips air vs heatmap is done with margin-top here, not
 * larger title margin-bottom (that was making this card taller).
 */
.RelatedConceptsPanel_chips-region__NTcMm {
  width: 100%;
  margin-top: 10px;
  height: 350px;
  min-height: 350px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.RelatedConceptsPanel_chips__T-rQh {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 9px;
  align-items: flex-start;
}

/* BenchmarkEntityPicker chip styling (filter bar) */
.RelatedConceptsPanel_chip__5T4Xc {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  padding: 4px 10px;
  border: none;
  cursor: pointer;
  background: #0f3460;
  color: #fff;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  transition: filter 0.15s, transform 0.12s;
}
.RelatedConceptsPanel_chip__5T4Xc:hover {
  filter: brightness(1.08);
}
.RelatedConceptsPanel_chip__5T4Xc:active {
  transform: scale(0.98);
}
.RelatedConceptsPanel_chip__5T4Xc:focus-visible {
  outline: 2px solid rgba(15, 52, 96, 0.45);
  outline-offset: 2px;
}
.RelatedConceptsPanel_chip__text__eN8EM {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: 240px;
  text-align: left;
}

.RelatedConceptsPanel_empty__x\\+DPy,
.RelatedConceptsPanel_error__dK9cZ {
  margin: 0;
  font-size: 14px;
  color: var(--grey-text, #8a8a8a);
}

.RelatedConceptsPanel_error__dK9cZ {
  color: #b91c1c;
}

.RelatedConceptsPanel_loading__Rrbce {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}

@media only screen and (max-width: 768px) {
  .RelatedConceptsPanel_card__b8nRG {
    padding: 18px 14px 14px;
  }
  .RelatedConceptsPanel_title__cyNDi {
    font-size: 18px;
  }
  .RelatedConceptsPanel_chips-region__NTcMm {
    margin-top: 10px;
    height: 310px;
    min-height: 310px;
  }
  .RelatedConceptsPanel_chip__text__eN8EM {
    max-width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/RelatedConceptsPanel/RelatedConceptsPanel.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,6EAAA;AAEA;EACE,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wEAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,wEAAA;AACF;;AAEA,4EAAA;AACA;EACE,gBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;;;;EAAA;AAKA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;EACA,uBAAA;AACF;;AAEA,oDAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,yCAAA;AACF;AACE;EACE,wBAAA;AACJ;AAEE;EACE,sBAAA;AAAJ;AAGE;EACE,yCAAA;EACA,mBAAA;AADJ;AAIE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;;AAMA;;EAEE,SAAA;EACA,eAAA;EACA,gCAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAHF;;AAMA;EACE;IACE,uBAAA;EAHF;EAMA;IACE,eAAA;EAJF;EAOA;IACE,gBAAA;IACA,aAAA;IACA,iBAAA;EALF;EAQA;IACE,gBAAA;EANF;AACF","sourcesContent":["/* Match BenchmarkHeatmap.module.scss .card + .title + chart height (360px) */\n\n.card {\n  padding: 24px 24px 18px;\n  background: var(--bg-2, #fff);\n  border-radius: 14px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  /* Title + 360px region mirrors BenchmarkHeatmap (title + chart 360px) */\n}\n\n/* Match BenchmarkHeatmap .title (margin 0 0 10px) so card heights line up */\n.title {\n  margin: 0 0 10px;\n  font-family: \"Lora\", \"Georgia\", serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-1, #1a1a1a);\n}\n\n/*\n * Same vertical band as heatmap title→chart: 10px gap + 360px plot.\n * Extra title→chips air vs heatmap is done with margin-top here, not\n * larger title margin-bottom (that was making this card taller).\n */\n.chips-region {\n  width: 100%;\n  margin-top: 10px;\n  height: 350px;\n  min-height: 350px;\n  box-sizing: border-box;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  gap: 9px;\n  align-items: flex-start;\n}\n\n/* BenchmarkEntityPicker chip styling (filter bar) */\n.chip {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 4px 10px;\n  border: none;\n  cursor: pointer;\n  background: #0f3460;\n  color: #fff;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  transition: filter 0.15s, transform 0.12s;\n\n  &:hover {\n    filter: brightness(1.08);\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba(15, 52, 96, 0.45);\n    outline-offset: 2px;\n  }\n\n  &__text {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n    max-width: 240px;\n    text-align: left;\n  }\n}\n\n.empty,\n.error {\n  margin: 0;\n  font-size: 14px;\n  color: var(--grey-text, #8a8a8a);\n}\n\n.error {\n  color: #b91c1c;\n}\n\n.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 120px;\n}\n\n@media only screen and (max-width: 768px) {\n  .card {\n    padding: 18px 14px 14px;\n  }\n\n  .title {\n    font-size: 18px;\n  }\n\n  .chips-region {\n    margin-top: 10px;\n    height: 310px;\n    min-height: 310px;\n  }\n\n  .chip__text {\n    max-width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `RelatedConceptsPanel_card__b8nRG`,
	"title": `RelatedConceptsPanel_title__cyNDi`,
	"chips-region": `RelatedConceptsPanel_chips-region__NTcMm`,
	"chips": `RelatedConceptsPanel_chips__T-rQh`,
	"chip": `RelatedConceptsPanel_chip__5T4Xc`,
	"chip__text": `RelatedConceptsPanel_chip__text__eN8EM`,
	"empty": `RelatedConceptsPanel_empty__x+DPy`,
	"error": `RelatedConceptsPanel_error__dK9cZ`,
	"loading": `RelatedConceptsPanel_loading__Rrbce`
};
export default ___CSS_LOADER_EXPORT___;
